import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="relative h-[80vh] min-h-[520px] w-full flex items-center justify-center overflow-hidden" data-id="element-158">
      {/* Full-bleed background image */}
      <img src="https://cdn.magicpatterns.com/uploads/jHx8YpbKv5aYkknVE29Tgc/4DDC8E39-9238-4D8E-9718-A6BA407A7ED2.png" alt="Mujer caminando por un sendero costero al amanecer, recuperando su libertad de movimiento" className="absolute inset-0 w-full h-full object-cover object-[72%_45%] sm:object-[60%_70%]" data-id="element-159" />

      {/* Soft elegant overlay for readability */}
      <div className="absolute inset-0 bg-warm-dark/40" data-id="element-160" />
      <div className="absolute inset-0 bg-gradient-to-t from-warm-dark/60 via-warm-dark/20 to-transparent" data-id="element-161" />

      {/* Centered content over the image */}
      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center" data-id="element-162">
        <FadeIn delay={0.15} data-id="element-163">
          <h1 className="text-4xl md:text-6xl lg:text-7xl text-white font-heading font-medium leading-tight mb-6 drop-shadow-md" data-id="element-164">
            Tu espalda merece una{' '}
            <span className="italic text-warm-alt" data-id="element-165">segunda oportunidad</span>
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-166">
          <p className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto mb-10 leading-relaxed drop-shadow" data-id="element-167">
            Una guía basada en una experiencia real de recuperación para
            ayudarte a entender tu dolor, recuperar confianza al moverte y
            volver a mirar el futuro con esperanza.
          </p>
        </FadeIn>

        <FadeIn delay={0.45} data-id="element-168">
          <Button href="#comprar" className="text-lg px-12 py-5 shadow-lg shadow-sage/30" data-id="element-169">
            Quiero mi guía ahora
          </Button>
        </FadeIn>
      </div>
    </section>;
}